<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import {useWorkerStore} from "@/stores/Worker/Worker";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        label: String,
        action: String,
        rules: Array,
        readonly: Boolean,
        disabled: Boolean,
        multiple: Boolean,
        externalLoading: Boolean,
        organizationalchartId: Number,
        loadByOrganizationalchartId: Boolean,
        notFetch: Boolean,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const {transformFilterValues} = useSharedMethod();
        
        const workerStore = useWorkerStore();
        
        const worker = ref(null);
        
        function findAll() {
            loading.value = true;
            let filter = {};
            filter.allRecords = true;
            filter.action = props.action;
            filter.sortBy = 'lastName';
            filter.phase = 'ACTIVE';
            if (props.loadByOrganizationalchartId) {
                filter.organizationalchartIds = [props.organizationalchartId];
            }
            axios.get('/workers/findAllForSelectPurpose', {params: transformFilterValues(filter)}).then(response => {
                workerStore.setWorkersSelect(response.data.sort((a, b) => a.name.localeCompare(b.name)))
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function input(val) {
            emit("input", val);
        }
        
        function clear() {
            emit("input", null);
        }
        
        watch(() => props.value, () => {
            worker.value = props.value;
        }, {immediate: true});
        
        watch(() => props.organizationalchartId, () => {
            if (!props.disabled) {
                findAll();
            }
        });
        
        onMounted(() => {
            if (!props.disabled && !props.notFetch) {
                findAll();
            }
        });
        
        return {
            workerStore,
            worker,
            loading,
            inputColor,
            backgroundColor,
            input,
            clear,
        }
    },
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="worker"
            :label="label"
            :items="workerStore.workersSelect"
            item-value="id"
            item-text="name"
            hide-no-data
            :chips="multiple"
            :deletable-chips="multiple"
            :color="inputColor"
            :background-color="backgroundColor"
            outlined
            :clearable="!readonly"
            dense
            :multiple="multiple"
            :loading="loading"
            hide-details="auto"
            @input="input"
            @click:clear="clear"
            :rules="rules"
            :readonly="readonly"
            :disabled="disabled"
        >
        </v-autocomplete>
        
        <input type="hidden"/>
    </div>
</template>